/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'auth'
import { createAction, handleActions } from 'redux-actions'
import { validatePaymentForm, validateResetPasswordForm, validateSignupForm } from '../../commons/formValidator'
import { PaymentEventDateType, PaymentRefererType } from '../../commons/PaymentFormStatus'
import { Plan } from '../../commons/Plan'
import { PaymentPageType } from '../containers/PaymentPage/PaymentPage'
import { SignupPageType } from '../containers/SignupPage/SignupPage'

export const CHANGE_LOGIN_FORM: any = createAction(`${BASE_ACTION_NAME}/change_login_form`)
export const POST_LOGIN: any = createAction(`${BASE_ACTION_NAME}/post_login`)
export const POST_LOGIN_SUCCESS: any = createAction(`${BASE_ACTION_NAME}/post_login/success`)
export const POST_LOGIN_FAILURE: any = createAction(`${BASE_ACTION_NAME}/post_login/failure`)

export const CHANGE_SIGNUP_FORM: any = createAction(`${BASE_ACTION_NAME}/change_signup_form`)
export const POST_SIGNUP: any = createAction(`${BASE_ACTION_NAME}/post_signup`)
export const POST_SIGNUP_SUCCESS: any = createAction(`${BASE_ACTION_NAME}/post_signup/success`)
export const POST_SIGNUP_FAILURE: any = createAction(`${BASE_ACTION_NAME}/post_signup/failure`)

export const SELECT_PLAN: any = createAction(`${BASE_ACTION_NAME}/select_plan`)
export const NEXT_TO_PAYMENT_FORM: any = createAction(`${BASE_ACTION_NAME}/next_to_payment_form`)
export const CHANGE_PAYMENT_FORM: any = createAction(`${BASE_ACTION_NAME}/change_payment_form`)
export const COMPLETE_CREATE_TOKEN: any = createAction(`${BASE_ACTION_NAME}/complete_create_token`)
export const FIX_PAYMENT_FORM: any = createAction(`${BASE_ACTION_NAME}/FIX_PAYMENT_FORM`)
export const POST_PAYMENT: any = createAction(`${BASE_ACTION_NAME}/post_payment`)
export const POST_PAYMENT_SUCCESS: any = createAction(`${BASE_ACTION_NAME}/post_payment/success`)
export const POST_PAYMENT_FAILURE: any = createAction(`${BASE_ACTION_NAME}/post_payment/failure`)

export const SET_CURRENT_USER: any = createAction(`${BASE_ACTION_NAME}/set_current_user`)

export const CHANGE_NEW_PASSWORD_FORM: any = createAction(`${BASE_ACTION_NAME}/change_new_password`)
export const CHANGE_NEW_PASSWORD_CHECK_FORM: any = createAction(`${BASE_ACTION_NAME}/change_new_password_for_check`)
export const POST_RESET_PASSWORD: any = createAction(`${BASE_ACTION_NAME}/post_reset_password`)
export const POST_RESET_PASSWORD_FAILURE: any = createAction(`${BASE_ACTION_NAME}/post_reset_password/failure`)
export const POST_RESET_PASSWORD_SUCCESS: any = createAction(`${BASE_ACTION_NAME}/post_reset_password/success`)

// 退会
export const WITHDRAW: any = createAction(`${BASE_ACTION_NAME}/withdraw`)
export const WITHDRAW_SUCCESS: any = createAction(`${BASE_ACTION_NAME}/withdraw/success`)
export const WITHDRAW_FAILURE: any = createAction(`${BASE_ACTION_NAME}/withdraw/failure`)

/////////////////
//// Reducer ////
/////////////////
export interface AuthState {
  currentUserId: string | undefined
  // login
  loginEmail: string
  loginPassword: string
  isLoginLoading: boolean
  loginError: string | null
  // signup
  signupEmail: string
  signupPassword: string
  signupPageType: number
  signupInputFormErrors: any
  isSignupLoading: boolean
  signupRequestError: string
  // payment
  paymentPlan: Plan | undefined
  paymentFirstName: string
  paymentFamilyName: string
  paymentPageType: number
  paymentCompleteCreditCard: boolean
  paymentInputFormErrors: any
  stripeToken: string | null
  cardLast4: string | null
  confirmError: string | null
  isPaymentLoading: boolean
  paymentSelectedDateOption: string
  paymentEventDate: string
  paymentSelectedRefererOption: string
  paymentOtherReferer: string
  // reset password
  newPassword: string
  newPasswordForCheck: string
  isResetPasswordLoading: boolean
  resetPasswordStatus: boolean | null
  resetPasswordInputFormErrors: any
  // withdraw
  isWithdrawLoading: boolean
  isWithdrawed: boolean
  withdrawError: string
}

const initialState: AuthState = {
  currentUserId: undefined,
  // login
  loginEmail: '',
  loginPassword: '',
  isLoginLoading: false,
  loginError: null,
  // signup
  signupPageType: SignupPageType.INPUT_FORM,
  signupEmail: '',
  signupPassword: '',
  signupInputFormErrors: {
    email: null,
    password: null
  },
  signupRequestError: '',
  isSignupLoading: false,
  paymentPlan: undefined,
  paymentFamilyName: '',
  paymentFirstName: '',
  paymentPageType: PaymentPageType.SELECT_PLAN,
  paymentCompleteCreditCard: false,
  paymentInputFormErrors: {
    name: null,
    creditCard: null
  },
  paymentSelectedDateOption: PaymentEventDateType.UNKNOWN,
  paymentEventDate: '',
  paymentSelectedRefererOption: PaymentRefererType.NO_ANSWER,
  paymentOtherReferer: '',
  stripeToken: null,
  cardLast4: null,
  isPaymentLoading: false,
  confirmError: null,
  newPassword: '',
  newPasswordForCheck: '',
  isResetPasswordLoading: false,
  resetPasswordStatus: null,
  resetPasswordInputFormErrors: {
    password: null
  },
  isWithdrawLoading: false,
  isWithdrawed: false,
  withdrawError: ''
}

export default handleActions(
  {
    [SET_CURRENT_USER]: (state: AuthState, { payload }: any) => ({
      ...state,
      currentUserId: payload.userId
    }),

    [CHANGE_LOGIN_FORM]: (state: AuthState, { payload }: any) => ({
      ...initialState,
      loginEmail: payload.email,
      loginPassword: payload.password
    }),

    [POST_LOGIN]: (state: AuthState) => ({
      ...state,
      isLoginLoading: true
    }),

    [POST_LOGIN_SUCCESS]: (state: AuthState) => ({
      ...initialState
    }),

    [POST_LOGIN_FAILURE]: (state: AuthState, { payload }: any) => ({
      ...state,
      isLoginLoading: false,
      loginError: payload
    }),

    [CHANGE_SIGNUP_FORM]: (state: AuthState, { payload }: any) => ({
      ...state,
      signupEmail: payload.email,
      signupPassword: payload.password,
      signupInputFormErrors: validateSignupForm(payload)
    }),

    [POST_SIGNUP]: (state: AuthState) => ({
      ...state,
      isSignupLoading: true
    }),

    [POST_SIGNUP_SUCCESS]: (state: AuthState) => ({
      ...state,
      isSignupLoading: false,
      signupPageType: SignupPageType.COMPLETE
    }),

    [POST_SIGNUP_FAILURE]: (state: AuthState, { payload }: any) => ({
      ...state,
      isSignupLoading: false,
      signupRequestError: payload.error.join('\n')
    }),

    [SELECT_PLAN]: (state: AuthState, { payload }: any) => ({
      ...state,
      paymentPlan: payload.plan
    }),

    [NEXT_TO_PAYMENT_FORM]: (state: AuthState) => ({
      ...state,
      paymentPageType: PaymentPageType.INPUT_FORM
    }),

    [CHANGE_PAYMENT_FORM]: (state: AuthState, { payload }: any) => ({
      ...state,
      paymentFirstName: payload.firstName,
      paymentFamilyName: payload.familyName,
      paymentCompleteCreditCard: payload.completeCreditCard,
      paymentInputFormErrors: validatePaymentForm(payload),
      paymentSelectedDateOption: payload.selectedDateOption,
      paymentEventDate: payload.eventDate,
      paymentSelectedRefererOption: payload.selectedRefererOption,
      paymentOtherReferer: payload.otherReferer
    }),

    [COMPLETE_CREATE_TOKEN]: (state: AuthState, { payload }: any) => ({
      ...state,
      stripeToken: payload.token.id,
      cardLast4: payload.token.card.last4,
      paymentPageType: PaymentPageType.CONFIRM
    }),

    [FIX_PAYMENT_FORM]: (state: AuthState) => ({
      ...state,
      paymentPageType: PaymentPageType.INPUT_FORM
    }),

    [POST_PAYMENT]: (state: AuthState) => ({
      ...state,
      isPaymentLoading: true
    }),

    [POST_PAYMENT_SUCCESS]: (state: AuthState) => ({
      ...state,
      isPaymentLoading: false,
      paymentPageType: PaymentPageType.COMPLETE
    }),

    [POST_PAYMENT_FAILURE]: (state: AuthState, { payload }: any) => ({
      ...state,
      isPaymentLoading: false,
      confirmError: payload.message
    }),
    [CHANGE_NEW_PASSWORD_FORM]: (state: AuthState, { payload }: any) => ({
      ...state,
      newPassword: payload.newPassword,
      resetPasswordInputFormErrors: validateResetPasswordForm(payload)
    }),
    [CHANGE_NEW_PASSWORD_CHECK_FORM]: (state: AuthState, { payload }: any) => ({
      ...state,
      newPasswordForCheck: payload.newPasswordForCheck
    }),
    [POST_RESET_PASSWORD]: (state: AuthState) => ({
      ...state,
      isResetPasswordLoading: true,
      resetPasswordStatus: null
    }),

    [POST_RESET_PASSWORD_SUCCESS]: (state: AuthState) => ({
      ...state,
      isResetPasswordLoading: false,
      resetPasswordStatus: true
    }),

    [POST_RESET_PASSWORD_FAILURE]: (state: AuthState, { payload }: any) => ({
      ...state,
      isResetPasswordLoading: false,
      loginError: payload,
      resetPasswordStatus: false
    }),

    [WITHDRAW]: (state: AuthState) => ({
      ...state,
      withdrawError: '',
      isWithdrawLoading: true
    }),
    [WITHDRAW_SUCCESS]: (state: AuthState) => ({
      ...state,
      withdrawError: '',
      isWithdrawLoading: false,
      isWithdrawed: true
    }),
    [WITHDRAW_FAILURE]: (state: AuthState, { payload }: any) => ({
      ...state,
      withdrawError: payload.message,
      isWithdrawed: false,
      isWithdrawLoading: false
    })
  },
  initialState
)
